///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.promos = abcsetup.promos || {};
abcsetup.promos.checkbooks = abcsetup.promos.checkbooks || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.promos.checkbooks = {
    /**
     * Make chevrons flip on promo entries accordions.
     */
    setupAccordions() {
        $('.promo-accordion .collapse')
            .off('show.bs.collapse')
            .on('show.bs.collapse', function () {
                const accordion = $(this).closest('.accordion');

                accordion.find('.open-chevron')
                    .removeClass('fa-chevron-up')
                    .addClass('fa-chevron-down');
            })
            .off('hide.bs.collapse')
            .on('hide.bs.collapse', function () {
                const accordion = $(this).closest('.accordion');

                accordion.find('.open-chevron')
                    .removeClass('fa-chevron-down')
                    .addClass('fa-chevron-up');
            })
    },

    /**
     * Setup the button which opens the supplier items modal.
     */
    setupPromoSupplierItemsModal(readonly = false) {
        $(document).on('click', '.promo-supplier-items-btn',
            e => this._openPromoSupplierItemsModal(e.target.dataset.entryId, readonly)
        );

        if (!readonly) {
            $(document).on('click', '.remove-item-from-checkbook-entry-btn', e => {
                if (window.confirm('Remove item from supplier\'s promo items?')) {
                    this._removeItemFromCheckbookEntry(e.target);
                }
            });
        }
    },

    /**
     * Show the supplier items listing modal for a promo.
     *
     * @param {number|string} entry_id
     * @param {boolean} readonly
     * @private
     */
    _openPromoSupplierItemsModal(entry_id, readonly) {
        const Modal = $('#promo-supplier-items-modal')
        const ModalBody = Modal.find('.modal-body');
        ModalBody.empty();

        abcsetup.blockUI(true);

        axios.get(`/api/promos/checkbook-entries/${entry_id}/items?readonly=${readonly ? 1 : 0}`)
            .then(response => {
                ModalBody.html(response.data.html)
                Modal.modal('show');
                abcsetup.unblockUI();
            });
    },

    /**
     *
     * @param {HTMLElement} RemoveButton
     * @private
     */
    _removeItemFromCheckbookEntry(RemoveButton) {
        abcsetup.blockUI(true);
        axios.delete(`/api/promos/checkbook-entries/items/${RemoveButton.dataset.entityItemId}`)
            .then(response => {
                const entry_id = $(RemoveButton).closest('table').data('entryId');
                const ItemRow = $(RemoveButton).closest('tr');
                const NextItemRow = ItemRow.next('tr');
                const EntryRow = $(`tr.checkbook-entries-${entry_id}`);
                const ItemsButton = EntryRow.find('.promo-supplier-items-btn');
                const BillingAmountInput = EntryRow.find('.field-billing_amount');

                // Decrement the items count for the entry in the UI.
                ItemsButton.text(Math.max(0, Number(ItemsButton.text()) - 1));
                BillingAmountInput.val(abcsetup.formatter.number(response.data.new_entry_cost, 2, false)).trigger('change');

                NextItemRow.find('.field_block_type_name').show();
                NextItemRow.find('.field_cost').show();

                ItemRow.remove();

                abcsetup.unblockUI();
            });
    }
}
